module.exports = __webpack_public_path__ + "img/More.288e31e7.svg";